import  Table, { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import TicketManagementThread from "./TicketManagementThread";
import { ConfigProvider } from "antd";
import fa_IR from "antd/lib/locale/fa_IR";
import { DatePicker as DatePickerJalali, JalaliLocaleListener, useJalaliLocaleListener } from "antd-jalali";
import moment from 'moment'
import Spinner from "../../components/_common/Spinner";
import { errorNotify } from "../../services/toast.notification";
import { getTicketList } from "../../api/api";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";

export interface InputProps {
    // labId: any,
    tableShow:boolean,
    fromDate:any,
    toDate:any
  }
  
  const TicketManagement = ({tableShow,fromDate,toDate}:InputProps) => {

    const columns: ColumnsType<any> = [
        {title: 'عنوان',dataIndex: 'str_TicketTitle',key: 'str_TicketTitle'},
        {title: 'کاربر',dataIndex: 'str_ProblemOwnerName',key: 'str_ProblemOwnerName'},
        {title: 'زمان',dataIndex: 'str_DisplayDateTime',key: 'str_DisplayDateTime'},
        {title: 'گروه',dataIndex: 'str_TicketType',key: 'str_TicketType'},
        {title: 'شرح',dataIndex: 'str_TicketDescription',key: 'str_TicketDescription'},
        {title: 'مهندس مرتبط',dataIndex: 'assignToUserName',key: 'assignToUserName'},  
    ];


  const myStore = useAppSelector((state) => state)
  const dispatch = useAppDispatch();
  const [isLoading,setIsLoading] = useState(false);
  const [data,setData] = useState([]);
  const [tableVisible,setTableVisible] = useState(tableShow);
  const [selectedId,setSelectedId] = useState(true);
  const [firstDate,setFirstDate] = useState<any>(fromDate);
  const [lastDate,setLastDate] = useState<any>(toDate);
  const [type, setType] = useState("All");
  const [filteredData, setFilteredData] = useState([]);

  const _getTicketList = (fromdate:any,todate:any) => {
    setIsLoading(true);
    getTicketList(Number(myStore.auth.userId),0,fromdate,todate)
    .then((result:any) => {
      setData(result.data.data);
      setFilteredData(result.data.data);
      setIsLoading(false);
      //console.log('backup info is: '+ result.data.json);
    })
    .catch((error) => {
      console.log(error);
      errorNotify(error.response.data.errorMessage,undefined,5000)
    }) 
    
    
}
const onChangeDatePicker = (dates:any,dateStrings:any,info:any) => {

    console.log(dates);
    if (!dateStrings) return;
    if (dateStrings.length < 2) return;
    if (dateStrings[0] === "") return;
    if (dateStrings[1] === "") return;

    setFirstDate(dates[0])
    setLastDate(dates[1])

    

    _getTicketList(dates[0].format('YYYY-MM-DD'),dates[1].format('YYYY-MM-DD'));
}
  useEffect(() => {
    _getTicketList(firstDate == ''? moment().format('YYYY-MM-DD') : firstDate.format('YYYY-MM-DD'),lastDate == ''?  moment().add(-1, 'months').format('YYYY-MM-DD') :lastDate.format('YYYY-MM-DD'));
  }, [])

  function onChangeValue(event:any) {
    setType(event.target.value);

    switch (event.target.value) {
      case 'All':          
          setFilteredData(data);
          break;
      case 'inProgress':
           const _newFilter = data.filter((value:any) => {
              return value.int_State == 0;
             });
        setFilteredData(_newFilter);
          break;
      case 'Done':
          const newFilter = data.filter((value:any) => {
              return value.int_State == 1;
             });
        setFilteredData(newFilter);
          break;
      case 'Cancel':
            const __newFilter = data.filter((value:any) => {
                return value.int_State == 2;
               });
          setFilteredData(__newFilter);
            break;
    }
  }
  return(
    <div>
       {
              tableVisible === true && (
         <div className="calender">
            <ConfigProvider locale={fa_IR} direction="rtl">
                <JalaliLocaleListener />
                <DatePickerJalali.RangePicker value={[firstDate,lastDate]}  onCalendarChange={(dates:any,dateStrings:any,info:any)=>onChangeDatePicker(dates,dateStrings,info)} />
            </ConfigProvider>
        </div>
              )
              }
     { 
        isLoading === false  && (
        <>
            <div className="inner-tabs_content">
                { 
             
             <>
             {
              tableVisible === true && (
                <div className="row">
                  <div onChange={onChangeValue} style={{display:'flex',marginBottom:'20px'}}>
                  <span style={{display:'flex',paddingLeft:'20px'}}><input type="radio" value="All" name="type" checked={type === "All"} /> همه</span>
                  <span style={{display:'flex',paddingRight:'20px'}}><input type="radio" value="inProgress" name="type" checked={type === "inProgress"}/> درحال پیگیری </span>
                  <span style={{display:'flex',paddingRight:'20px'}}><input type="radio" value="Done" name="type" checked={type === "Done"}/> انجام شده </span>
                  <span style={{display:'flex',paddingRight:'20px'}}><input type="radio" value="Cancel" name="type" checked={type === "Cancel"}/> کنسل شده </span></div>
                <Table  onRow={(record, rowIndex) => {
                  return {
                    onClick: event => { 
                      setTableVisible(false);
                      setSelectedId(record.prk_SupportTicket_AutoID);
                    },
                  } }}   
                  dataSource={filteredData} columns={columns}
                /> 
                </div>
              )
             } 
              {
                tableVisible === false && (
                <TicketManagementThread fromDate={firstDate} toDate={lastDate} ticketId={selectedId}  />
                )
              }
            </> 
                }
                
        </div>
        </> 
        )
    }
    {
      isLoading === true  && (
      <Spinner />
    )
    }
    </div>  
      
    )
}
export default TicketManagement;
